import { render } from "./FiltroSubTipo.vue?vue&type=template&id=40f1fbc6&scoped=true"
import script from "./FiltroSubTipo.vue?vue&type=script&lang=js"
export * from "./FiltroSubTipo.vue?vue&type=script&lang=js"

import "./FiltroSubTipo.vue?vue&type=style&index=0&id=40f1fbc6&scoped=true&lang=css"

import exportComponent from "D:\\FOP\\AGAPE\\AGAPE_HOSPITALAR\\ReguaHospitalar\\frontpainel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40f1fbc6"]])

export default __exports__